import { athleteDirectorySearchResponseSchema } from "../schemas/athlete";
import { fetchApi } from "./internal";

// Discovery directory search (public, Meilisearch-backed). Served by the same API
// gateway as the club routes; used by the DVV link picker to find scraped athletes.
export const athletes = {
	search: (params: { q: string; federation?: string; limit?: number }) => {
		const searchParams = new URLSearchParams({ q: params.q });
		if (params.federation) searchParams.set("federation", params.federation);
		searchParams.set("limit", String(params.limit ?? 10));
		return fetchApi(
			`/public/directory/athletes?${searchParams.toString()}`,
			athleteDirectorySearchResponseSchema,
		);
	},
};
